/* src/app/koffer/koffer.component.scss */
.bg {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  z-index: 10;
}
/*# sourceMappingURL=koffer.component.css.map */
